export const init = () => {
  const items = document.querySelectorAll(".servicio-list");
  if (!items.length) return;

  items.forEach((item) => {
    const description = item.querySelector(".servicio-list__description");
    if (!description) return;

    // Set initial state
    window.gsap.set(description, { height: 0, opacity: 0, overflow: "hidden" });

    const tl = window.gsap.timeline({ paused: true });

    tl.to(description, {
      height: "auto",
      opacity: 1,
      duration: 0.4,
      ease: "power2.out",
    });

    item.addEventListener("mouseenter", () => {
      tl.play();
    });

    item.addEventListener("mouseleave", () => {
      tl.reverse();
    });
  });
};
